import { useEffect, useState } from "react";
import { ChevronRight } from "./icons";

interface Props {
  loName: string;
  redirectUrl: string;
  onRedirect: (url: string) => void;
  onCancel: () => void;
}

const COUNTDOWN = 5;

export default function EndOfVideoCard({ loName, redirectUrl, onRedirect, onCancel }: Props) {
  const [n, setN] = useState(COUNTDOWN);

  useEffect(() => {
    if (n <= 0) {
      onRedirect(redirectUrl);
      return;
    }
    const t = window.setTimeout(() => setN(n - 1), 1000);
    return () => window.clearTimeout(t);
  }, [n, redirectUrl, onRedirect]);

  return (
    <div className="eov" role="dialog" aria-label="Continue to loan officer page">
      <div className="eov__inner">
        <div className="eov__eyebrow">Thanks for watching</div>
        <div className="eov__headline">Continue to {loName}'s page</div>
        <div className="eov__sub">Redirecting in {n}…</div>
        <div className="eov__actions">
          <button
            className="btn btn--primary btn--lg"
            onClick={(e) => { e.preventDefault(); onRedirect(redirectUrl); }}
          >
            Continue now <ChevronRight size={16} />
          </button>
          <button className="btn btn--ghost" onClick={onCancel}>
            Stay here
          </button>
        </div>
      </div>
    </div>
  );
}
